module.exports = __webpack_public_path__ + "static/media/QAP2EL-feature.40c659ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/QAP2EL-feature.png
// module id = 1027
// module chunks = 0